/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/packages/packages-i18n/
 */
import { __ } from '@wordpress/i18n';
import { useBlockProps, RichText, InspectorControls, BlockControls, AlignmentToolbar } from '@wordpress/block-editor';
import { ToggleControl, PanelBody, PanelRow, CheckboxControl, SelectControl, ColorPicker, IconButton, Toolbar } from '@wordpress/components';
import { Fragment, useState, useEffect } from "@wordpress/element";
import { apiFetch } from '@wordpress/api-fetch';
import $ from 'jquery';

/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * Those files can contain any CSS code that gets applied to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import './editor.scss';

/**
 * The edit function describes the structure of your block in the context of the
 * editor. This represents what the editor will render when the block is used.
 *
 * @see https://developer.wordpress.org/block-editor/developers/block-api/block-edit-save/#edit
 *
 * @param {Object} [props]           Properties passed from the editor.
 * @param {string} [props.className] Class name generated for the block.
 *
 * @return {WPElement} Element to render.
 */
export default function Edit( props ) {
    var subject_display = [];
    var bOutput = [];
    var childSubjects = [];
    var subjects = [];
    var key;
    let sortbox;
    let heading;
    var checkedState;
    var selectedSortOption;

    const checkedBox = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" role="img" class="components-checkbox-control__checked" aria-hidden="true" focusable="false"><path d="M18.3 5.6L9.9 16.9l-4.6-3.4-.9 1.2 5.8 4.3 9.3-12.6z"></path></svg>';

    String.prototype.ucwords = function() {
      var str = this.toLowerCase();
      return str.replace(/(^([a-zA-Z\p{M}]))|([ -][a-zA-Z\p{M}])/g,
        function(s){
          return s.toUpperCase();
        });
    };

    // Check if function is a constructor
    const isConstructor = (func) => {
        try {
            new func();
        }  catch (err){
            return false;
        } 
        return true;
    }

    const { attributes, setAttributes, clientId } = props;

    const getSubjectAreas =() => {
        // pretty permalink structure
        if (oer_subject_resources.perm_structure){
            wp.apiFetch( { url:oer_subject_resources.home_url  + '/wp-json/oer/v2/subjects/'} ).then( subjects => {
                setAttributes( { subjects: subjects } );
            });
        } else {
            // plain permalink structure
            wp.apiFetch( { url:oer_subject_resources.home_url  + '?rest_route=/oer/v2/subjects/'} ).then( subjects => {
                setAttributes( { subjects: subjects } );
            });
        }
    }

    useEffect(() => {
        getSubjectAreas();
    },[]);

    const getOptions = () => {
        if (typeof wp.api.collections !== 'undefined'){
            if (typeof wp.api.collections === 'object' && isConstructor(wp.api.collections.Posts)) {
                return ( new wp.api.collections.Posts() ).fetch().then( (posts) => {
                    if (typeof this.state.selectedSubject !== 'undefined'){
                        if ( posts && 0 !== this.state.selectedSubject ){
                            const post = posts.find( (item) => { return item.id == this.state.selectedSubject } );

                            this.setState( { post, posts });
                        } else {
                            this.setState( {posts} );
                        }
                    }
                });
            }
        }
    }
    
    const onChangeDisplayCount = ( newValue ) => {
        setAttributes( { displayCount: newValue, isChanged: true } );
        selectResources(true);
    }

    const onChangeSelectedSubject = ( newValue ) => {
        const post = this.state.posts.find( (item) => { return item.id==parseInt(newValue)} );
        this.setState( { selectedSubject: parseInt(newValue), post } );
        setAttributes( { 
            selectedSubject: parseInt(value),
            title: post.title.rendered,
            content: post.excerpt.rendered,
            link: post.link,
            isChanged: true
        } );
        selectResources(true);
    }

    const onChangeSorting = ( newValue ) => {
        setAttributes( { sort: newValue, isChanged: true} );
        selectResources(true);
    }

    const sortSubjects = (a,b) => {
        if(a.label < b.label) { return -1; }
        if(a.label > b.label) { return 1; }
        return 0;
    }

    const getChildSubjects = ( subject_id ) => {
        var output;
        var subjectAreas = new wp.api.models.ResourceSubjectArea;
        var resource_subjects = [];
        subjectAreas.fetch( { data: { per_page: 100, parent: subject_id  } } ).then( (subjects) => {
            if (subjects.length>0){
                resource_subjects = [].concat.apply(resource_subjects,subjects);
                resource_subjects = resource_subjects.sort(this.sortSubjects);
                this.setState({ childSubjects: resource_subjects });
                return resource_subjects;
            }
        });
    }

    /**-- Select resources after selecting a subject --**/
    const selectResources = ( reload ) => {
        var subjects = attributes.selectedSubjects;
        var count = attributes.displayCount;
        var sortOption = attributes.sort;
        var resources;
        if (typeof wp.api.collections === 'object' && isConstructor(wp.api.collections.Resource)) {
            resources = new wp.api.collections.Resource();
            if (attributes.selectedSubjects){
                resources.fetch( { data: { per_page: count, orderby: sortOption, order: 'asc', 'resource-subject-area': subjects  } } ).then( (posts) => {
                    setAttributes( { selectedSubjectResources: posts } );
                } );  
            } else {
                resources.fetch( { data: { per_page: count, orderby: sortOption, order: 'asc'  } } ).then( (posts) => {
                    setAttributes( { selectedSubjectResources: posts } );
                }); 
            }
        }
    }

    const oer_preview_subject_resources = (props) => {
        var responseText;
        var data = {
            action : 'oer_get_subject_resources',
            attributes: JSON.stringify(props),
        };
        $.ajax({ 
            url:oer_subject_resources.ajax_url, 
            type:'POST',
            data: data,
            dataType: 'html',
            async: false,
            success:function(response){
                responseText = response;
            },
            error: function(XMLHttpRequest, textStatus, errorThrown){
                console.log(errorThrown);
            }
        })
        return responseText;
    }

    const setBlockId = (blockId) =>  { setAttributes( { blockId } ); }

    if( clientId !== attributes.blockId ){
        setBlockId(clientId);
    }

    if (attributes.firstLoad){
        setTimeout( function() { 
            selectResources(false);
        }, 2000);
        setAttributes({ firstLoad: false });
    }

    let display_count_options = [ 
        { value:"5", label: __('5') }, 
        { value:"10", label: __('10') }, 
        { value:"15", label: __('15') }, 
        { value:"20", label: __('20') }, 
        { value:"25", label: __('25') },
        { value:"30", label: __('30') } 
    ];
    let sort_options = [
        { value:'modified', label:__('Date Updated', 'oer-subject-resources-block')},
        { value:'date', label:__('Date Added', 'oer-subject-resources-block')},
        { value:'title', label:__('Title a-z', 'oer-subject-resources-block')},
    ];

    if (typeof attributes.subjects === 'undefined' ){
        bOutput = __('Loading...', 'oer-subject-resources-block');
    } else {
        subjects = attributes.subjects.sort(sortSubjects);
    }

    const subject_areas_display = subjects.map( ( subject, index) => {
        if ($.inArray(subject.term_id,attributes.selectedSubjects)!==-1)
            checkedState = true;
        else
            checkedState = false;
        return (
            <CheckboxControl 
            value = { subject.term_id } 
            label =  { subject.name } 
            key = { index }
            name = "selectedSubjects[]" 
            className = { (subject.type=='child')?'oer-subject-area-child':'oer-subject-area-parent' }
            checked = { checkedState[index] }
            id = { subject.term_id }
            onChange = { function (val) {
                let data = (attributes.selectedSubjects) ? attributes.selectedSubjects: [];
                checkedState = val;
                $("#" + subject.term_id).prop("checked", checkedState);
                if (checkedState)
                    $("#" + subject.term_id).parent().append(checkedBox);
                if (val){
                    checkedState = true;
                    data.push(subject.term_id);
                    /**--if (typeof data !== 'undefined') {
                        if (data.indexOf(subject.term_id) === -1) {
                            data.push(subject.term_id)
                        }
                    } else {
                        data.push(subject.term_id);
                    }--**/
                } else {
                    checkedState = false;
                    data = attributes.selectedSubjects.filter((v) => v !== subject.term_id);
                }
                setAttributes({ selectedSubjects: data, isChanged: true });
                selectResources(true);
            } }
        />)
        });

    if (typeof attributes === 'undefined'){
        bOutput = 'Loading...';
    } else {
        bOutput = oer_preview_subject_resources(attributes);
        setAttributes({ isChanged:false });
    }    

    return [(
        <Fragment>
            <InspectorControls className="oer-subject-resources-block-inspector">
                <PanelBody
                    title={__("OER Subject Resources Option","oer-subject-resources-block")}
                    initialOpen={true}
                >
                    <PanelRow>
                        <div className="form-group oer-inspector-subjects">
                            <label>{ __("Subject(s):","oer-subject-resources-block")}</label>
                            <div className="editor-post-taxonomies__hierarchical-terms-list">
                                { subject_areas_display }
                            </div>
                        </div>
                    </PanelRow>
                    <PanelRow>
                        <SelectControl
                            className="display-count"
                            label={ __("# of Resources to display:", "oer-subject-resources-block") }
                            value={ attributes.displayCount }
                            options={ display_count_options }
                            onChange={ onChangeDisplayCount }
                        />
                    </PanelRow>
                    <PanelRow>
                        <SelectControl
                            className="sort-option"
                            label={ __("Sort:","oer-subject-resources-block") }
                            value={ attributes.sort }
                            options={ sort_options }
                            onChange={ onChangeSorting }
                        />
                    </PanelRow>
                </PanelBody>
            </InspectorControls>
        </Fragment>
        ),
        <div { ...useBlockProps() }><div className="oer-subject-resources-list" dangerouslySetInnerHTML={{__html: bOutput }}>
        </div></div>]
}
